import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { Alert } from "components/bootstrap";
import { StyledHeading, DescriptionCol } from "components/inputs/InputSetupWizard";
import IlluminateList from "./IlluminateList";
import { ILLUMINATE_PACK_TYPES } from "../SelectIlluminateStep";
const SelectProcessingPacks = ({
  selectedProcessingPacks,
  setSelectedProcessingPacks,
  isLoadingProcessingPacks,
  processingPacksData,
  setTouched
}) => {
  const productName = useProductName();
  const illuminateInfoText = `Illuminate Packs contain parsing rules that format logs to the GIM schema that is used by Illuminate Spotlight Packs and ${productName} Security Content.`;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledHeading, null, "Select Illuminate Packs"), /* @__PURE__ */ React.createElement(DescriptionCol, null, processingPacksData.length > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("p", null, "Please select one or more Illuminate Packs to use with logs received from this Input.", /* @__PURE__ */ React.createElement("br", null), illuminateInfoText), /* @__PURE__ */ React.createElement("p", null, "Selected packs will be enabled, if not already.")) : /* @__PURE__ */ React.createElement("p", null, " ", illuminateInfoText)), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "If not planning to use an Illuminate pack or Spotlight content with logs from this input, please proceed instead with the ", /* @__PURE__ */ React.createElement("em", null, "Skip Illuminate"), " option."), /* @__PURE__ */ React.createElement(
    IlluminateList,
    {
      isLoading: isLoadingProcessingPacks,
      listData: processingPacksData,
      selectedPacks: selectedProcessingPacks,
      setSelectedPacks: setSelectedProcessingPacks,
      setTouched,
      type: ILLUMINATE_PACK_TYPES.PROCESSING
    }
  ));
};
export default SelectProcessingPacks;
